/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';

class WordpressSelector extends React.Component {
    render() {
        return (
            <div>
                <ChooserHeader
                    {...this.props}
                    error={this.props.error}
                    headerCopy="Select a Wordpress Site"/>
                <ChooserMain
                    {...this.props}
                    allConnectedMessage={(
                        <p className="chooser-notice">You've already connected all your Wordpress sites to dlvr.it</p>
                    )}
                    typeLabel="Wordpress site"/>
            </div>
        );
    }
}

WordpressSelector.displayName = "WordpressSelector";

export default WordpressSelector;
